export default __webpack_public_path__ + "static/media/basic-pin-small-13.dca970d3.png";